import { Pipe, PipeTransform } from '@angular/core';
import { IStatement } from '../../../../../shared/models/scorecard-section.model';

@Pipe({
  name: 'order',
  standalone: true,
})
export class OrderPipe implements PipeTransform {
  transform(statement: IStatement, showHiddenQuestions: boolean, statements: IStatement[]): number {
    return (
      statements.filter(({ isHidden }) => showHiddenQuestions || !isHidden).findIndex(({ id }) => statement.id === id) +
      1
    );
  }
}
